<template>
  <div class="user-activity-combined" data-test-id="user-activity-combined">
    <span v-if="userCreated">
      {{ $t('prop.created') }}
      <TimeSince v-if="dateCreated" :date="new Date(dateCreated)" />

      <span>&nbsp;{{ $t('by') }} {{ userCreated.fullname || $t('deletedUser') }}.</span>
    </span>
    <span v-if="userUpdated">
      &nbsp;{{ $t('prop.updated') }}
      <TimeSince v-if="dateUpdated" :date="new Date(dateUpdated)" />

      <span>&nbsp;{{ $t('by') }} {{ userUpdated.fullname || $t('deletedUser') }}.</span>
    </span>
    <span v-if="codeCount || quotationCount">
      &nbsp;{{ $t('userActivityCombined.documentContains') }}
      <span v-if="quotationCount">
        {{ quotationCount }} {{ $t('entity.quotation', quotationCount)
        }}<span v-if="quotationCount && !codeCount">.</span>
      </span>
      <span v-if="quotationCount && codeCount">&nbsp;{{ $t('filter.and') }}</span>
      <span v-if="codeCount">&nbsp;{{ codeCount }} {{ $t('entity.code', codeCount) }}.</span>
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'UserActivityCombined',
  props: {
    userCreated: {
      type: Object,
      default: null,
    },

    userUpdated: {
      type: Object,
      default: null,
    },

    dateCreated: {
      type: String,
      default: null,
    },

    dateUpdated: {
      type: String,
      default: null,
    },
    quotationCount: {
      type: Number,
      required: false,
      default: 0,
    },
    codeCount: {
      type: Number,
      required: false,
      default: 0,
    },
  },
});
</script>
